import { Model, modelRegistry } from './Model';
import { Table } from '../models';
import { BeachBookingStatusType, BeachPaymentStatusType } from '../types';
import moment from 'moment-timezone';
export class BeachBooking extends Model {
    static entity = 'beach_bookings';
    static primaryKey = 'id';
    static syncable = false;
    id = 0;
    hash = '';
    tenant_id = 0;
    table_id = 0;
    beach_zone_id = 0;
    reference = '';
    guest_name = '';
    guest_email = '';
    guest_phone = '';
    guest_id = null;
    booking_date = '';
    status = BeachBookingStatusType.confirmed;
    amount = '0.00';
    commission_amount = '0.00';
    payment_status = BeachPaymentStatusType.pending;
    payment_gateway_ref = null;
    checked_in_at = null;
    checked_in_by = null;
    checked_out_at = null;
    released_at = null;
    special_requests = null;
    language = 'en';
    created_at = '';
    updated_at = '';
    constructor(record) {
        super();
        this.$fill(record);
    }
    static fields() {
        return {
            id: this.attr(0),
            hash: this.attr(''),
            tenant_id: this.attr(0),
            table_id: this.attr(0),
            beach_zone_id: this.attr(0),
            reference: this.attr(''),
            guest_name: this.attr(''),
            guest_email: this.attr(''),
            guest_phone: this.attr(''),
            guest_id: this.attr(null),
            booking_date: this.attr(''),
            status: this.attr(BeachBookingStatusType.confirmed),
            amount: this.attr('0.00', (value) => this.round(value, 2).toFixed(2)),
            commission_amount: this.attr('0.00', (value) => this.round(value, 2).toFixed(2)),
            payment_status: this.attr(BeachPaymentStatusType.pending),
            payment_gateway_ref: this.attr(null),
            checked_in_at: this.attr(null),
            checked_in_by: this.attr(null),
            checked_out_at: this.attr(null),
            released_at: this.attr(null),
            special_requests: this.attr(null),
            language: this.attr('en'),
            created_at: this.attr(''),
            updated_at: this.attr(''),
        };
    }
    // --- Static Queries ---
    /** Get all bookings for a specific date */
    static forDate(date) {
        return BeachBooking.all().filter(b => b.booking_date === date);
    }
    /** Get today's bookings */
    static todaysBookings() {
        return BeachBooking.forDate(moment().format('YYYY-MM-DD'));
    }
    /** Get today's active bookings for a specific table */
    static forTable(tableId) {
        const today = moment().format('YYYY-MM-DD');
        return BeachBooking.all().filter(b => b.table_id === tableId && b.booking_date === today && b.isActive());
    }
    /** Get booking for a specific table and date. The active one wins; a
     *  no-show surfaces only when nothing active exists — filtering no-shows
     *  out entirely made the floor plan's no_show state unreachable. */
    static forTableAndDate(tableId, date) {
        const sameDay = BeachBooking.all().filter(b => b.table_id === tableId && b.booking_date === date);
        return sameDay.find(b => b.isActive()) ?? sameDay.find(b => b.isNoShow());
    }
    // --- Instance Helpers ---
    /** Is this booking in an active state (not checked out or released)? */
    isActive() {
        return this.status === BeachBookingStatusType.confirmed
            || this.status === BeachBookingStatusType.checked_in
            || this.status === BeachBookingStatusType.held;
    }
    isHeld() {
        return this.status === BeachBookingStatusType.held;
    }
    isCheckedIn() {
        return this.status === BeachBookingStatusType.checked_in;
    }
    isConfirmed() {
        return this.status === BeachBookingStatusType.confirmed;
    }
    isNoShow() {
        return this.status === BeachBookingStatusType.no_show;
    }
    isCheckedOut() {
        return this.status === BeachBookingStatusType.checked_out;
    }
    /** Is this a walk-in (no portal reservation)? */
    isWalkIn() {
        return !this.guest_email && this.payment_status === BeachPaymentStatusType.pending;
    }
    getTable() {
        return Table.find(this.table_id);
    }
}
export default BeachBooking;
modelRegistry.register('BeachBooking', BeachBooking);
//# sourceMappingURL=BeachBooking.js.map